module.exports = __webpack_public_path__ + "static/media/mail.d0ac34ca.svg";